module.exports = __webpack_public_path__ + "vikatan-100-logo-53e868d02e7c4a261571.png";